import { Link } from "react-router-dom";
import { BookOpen, Plus } from "react-feather";
import { useT } from "@reciperoll/core";

// Shown when there are no recipes yet.
export default function EmptyHome() {
  const t = useT();
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-10">
      <BookOpen className="w-14 h-14 text-terracotta mb-6" />
      <h2 className="font-display text-3xl font-bold text-ink mb-2">
        {t("home.kitchenQuiet")}
      </h2>
      <p className="text-base text-ink-soft mb-8 leading-relaxed max-w-sm">
        {t("home.kitchenQuietSub")}
      </p>
      <Link
        to="/recipes/new"
        className="flex items-center gap-2 bg-terracotta hover:bg-terracotta-dark transition-colors rounded-xl px-6 py-3.5 text-base font-semibold text-white"
      >
        <Plus className="w-[18px] h-[18px]" />
        {t("library.addRecipe")}
      </Link>
    </div>
  );
}
